import HyperlinkSales from "@/components/functionals/HyperlinkSales";
import TagCell from "@/components/functionals/TagCell";
import HyperlinSalesTotal from "@/components/functionals/HyperlinSalesTotal";
import CellDateTime from "@/components/functionals/DatetimeFormatter.vue";
import {
  formatDate

  // FormatPercentSalesKpi,
} from "../utils";
//import ColorType from "@/components/functionals/ColorType.vue";
export const Months = [
  {
    prop: "January",
    label: "Enero",
    minWidth: 130,
    //fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 1
    },
    formatter: HyperlinkSales
  },
  {
    prop: "February",
    label: "Febrero",
    minWidth: 130,
    //fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 2
    },
    formatter: HyperlinkSales
  },
  {
    prop: "March",
    label: "Marzo",
    minWidth: 130,
    //fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 3
    },
    formatter: HyperlinkSales
  },
  {
    prop: "April",
    label: "Abril",
    minWidth: 130,
    aling: "center",
    //fixed: true,
    cellAtrrs: {
      mes: 4
    },
    formatter: HyperlinkSales
  },
  {
    prop: "May",
    label: "Mayo",
    minWidth: 130,
    //fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 5
    },
    formatter: HyperlinkSales
  },
  {
    prop: "June",
    label: "Junio",
    minWidth: 130,
    //fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 6
    },
    formatter: HyperlinkSales
  },
  {
    prop: "July",
    label: "Julio",
    minWidth: 130,
    //fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 7,
      mes2: "July"
    },
    formatter: HyperlinkSales
  },
  {
    prop: "August",
    label: "Agosto",
    minWidth: 130,
    //fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 8
    },
    formatter: HyperlinkSales
  },
  {
    prop: "September",
    label: "Septiembre",
    cellAtrrs: {
      mes: 9
    },
    minWidth: 130,
    //fixed: true,
    aling: "center",
    formatter: HyperlinkSales
  },
  {
    prop: "October",
    label: "Octubre",
    cellAtrrs: {
      mes: 10
    },
    minWidth: 130,
    //fixed: true,
    aling: "center",
    formatter: HyperlinkSales
  },
  {
    prop: "November",
    label: "Noviembre",
    cellAtrrs: {
      mes: 11
    },
    minWidth: 130,
    //fixed: true,
    aling: "center",
    formatter: HyperlinkSales
  },
  {
    prop: "December",
    label: "Diciembre",
    cellAtrrs: {
      mes: 12
    },
    minWidth: 130,
    //fixed: true,
    aling: "center",
    formatter: HyperlinkSales
  },
  {
    prop: "Totals",
    label: "Total",
    minWidth: 130,
    fixed: "right",
    formatter: HyperlinSalesTotal
  }
];

export const PaymentDetails = [
  {
    prop: "Date",
    label: "Fecha",
    minWidth: 80,
    fixed: true,
    formatter: CellDateTime
  },

  {
    prop: "AmountFormat",
    label: "Monto",
    minWidth: 80,
    fixed: true
  },
  {
    prop: "Tiempo",
    label: "Tiempo",
    minWidth: 80,
    fixed: true,
    formatter: TagCell
  },

  {
    prop: "Qty",
    label: "Equipos",
    minWidth: 80,
    fixed: true
  },

  {
    prop: "TipoContrato",
    label: "Facturación",
    minWidth: 100,
    fixed: true,
    formatter: TagCell
  },

  {
    prop: "CustomerName",
    label: "Cliente",
    minWidth: 190,
    fixed: true
  },

  {
    prop: "CustomerNo",
    label: "COD.",
    minWidth: 80,
    fixed: true
  },

  {
    prop: "Service",
    label: "Servicio",
    minWidth: 190,
    fixed: true
  },

  {
    prop: "Contract",
    label: "Contrato",
    minWidth: 80,
    fixed: true
  }
];
export const commentColumns = [
  {
    prop: "user",
    label: "Usuario",
    minWidth: 50,
    fixed: true
  },
  {
    prop: "Fecha",
    label: "Fecha",
    minWidth: 50,
    fixed: true,
    sortable: true,
    formatter: (row) => formatDate(row.Fecha, "DD/MM/yyyy")
  },
  {
    prop: "Comment",
    label: "Comentario",
    minWidth: 200
  }
];
